/* eslint-disable no-unused-vars */
import { Card, CardHeader, Box } from '@mui/material';
import { BaseOptionChart } from '../../../components/chart';

import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';

AppGraphsBar.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  name: PropTypes.string,
  chartData: PropTypes.array,
  chartLabels: PropTypes.arrayOf(PropTypes.string)
};

export default function AppGraphsBar({ title, subheader, chartLabels, chartData, ...other }) {
  const infosGraphsBar = {
    series: [
      {
        data: chartData
      }
    ],
    options: {
      legend: {
        show: false
      },
      chart: {
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          barHeight: chartData.length > 2 ? '90%' : '10%',
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: 'bottom'
          }
        }
      },
      dataLabels: {
        enabled: true
      },
      xaxis: {
        categories: chartLabels
      },
      labels: chartLabels,
      tooltip: {
        theme: 'light',
        x: {
          show: true
        },
        y: {
          title: {
            formatter: function () {
              return '';
            }
          }
        }
      }
    }
  };

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={infosGraphsBar.series}
          options={infosGraphsBar.options}
          height={335}
        />
      </Box>
    </Card>
  );
}
